var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19V22.9958C12.0001 23.8867 10.9229 24.3328 10.293 23.7029L3.29717 16.7071C2.90664 16.3166 2.90664 15.6834 3.29717 15.2929L10.293 8.29708C10.9229 7.66711 12.0001 8.11328 12.0001 9.00418V13H22.0001V9.00237C22.0001 8.11172 23.0767 7.66544 23.7068 8.29489L30.7118 15.2925C31.1029 15.6831 31.1029 16.3168 30.7118 16.7075L23.7068 23.705C23.0767 24.3345 22.0001 23.8882 22.0001 22.9976V19H12.0001Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 17V20.5852L28.5901 16L24.0001 11.4148V15H10.0001V11.4184L5.41849 16L10.0001 20.5815V17H24.0001ZM22.0001 9.00237C22.0001 8.11172 23.0767 7.66544 23.7068 8.29489L30.7118 15.2925C31.1029 15.6831 31.1029 16.3168 30.7118 16.7075L23.7068 23.705C23.0767 24.3345 22.0001 23.8882 22.0001 22.9976V19H12.0001V22.9958C12.0001 23.8867 10.9229 24.3328 10.293 23.7029L3.29717 16.7071C2.90664 16.3166 2.90664 15.6834 3.29717 15.2929L10.293 8.29708C10.9229 7.66711 12.0001 8.11328 12.0001 9.00418V13H22.0001V9.00237Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_182",
    x: 0.00427246,
    y: 6.50037,
    width: 34.0009,
    height: 21.9991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_182",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorHorizontal);
export default __webpack_public_path__ + "static/media/cursor-horizontal.1385da198f695acb23c9f9b1907af318.svg";
export { ForwardRef as ReactComponent };